export const AGENCY_SOMNIUM = 'somnium';
